import { render, staticRenderFns } from "./InactivePanel.vue?vue&type=template&id=874464f2"
import script from "./InactivePanel.vue?vue&type=script&lang=js"
export * from "./InactivePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports